<template>
  <div class="homelatest ml-1">
    <div class="comp-title">
      <div class="left">
        <h1 class="text-uppercase color-text-bold">
          <img src="../../../../static/img/comp-title.png"/>
          Cùng ca sĩ
        </h1>
      </div>
    </div>

    <div style="clear:both;"></div>

    <div class="content">
      <div v-for="item in songList" class="item mb-4">
        <a :href="settings.prefixSong + item.id + '/' + convertToAlias(item.song)">
          <img class="thumbnail" :src="item.thumbnail != '' ? item.thumbnail : settings.defaultThumbnailSong"/>
          <h4 class="song color-text">{{ item.song }}</h4>
          <p class="singer color-text">{{ item.singer }}</p>
          <p class="songcode font-size-13 color-text font-weight-bold">Mã: {{ item.code }}</p>
          <!--<p class="songcode font-size-13 color-text font-weight-bold">{{ item.RingBackTone != "" ? 'Mã: ' + item.RingBackTone : settings.updating }}</p>-->
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "MusicTop",
    props: {
      songList: Array
    },
    data () {
      return {
        dataList: [
          {
            "id": 1,
            "song": "Giật mình trong đêm",
            "singer": "Tuấn hưng",
            "songCode": "124667",
            "thumbnail": "https://c-sf.smule.com/rs-s78/arr/fa/6b/3a2241ec-2b2f-41ab-9442-e02c80a935e4.jpg"
          },
          {
            "id": 2,
            "song": "Giật mình trong đêm",
            "singer": "Tuấn hưng",
            "songCode": "124667",
            "thumbnail": "https://c-sf.smule.com/rs-s78/arr/fa/6b/3a2241ec-2b2f-41ab-9442-e02c80a935e4.jpg"
          },
          {
            "id": 3,
            "song": "Giật mình trong đêm",
            "singer": "Tuấn hưng",
            "songCode": "124667",
            "thumbnail": "https://c-sf.smule.com/rs-s78/arr/fa/6b/3a2241ec-2b2f-41ab-9442-e02c80a935e4.jpg"
          },
          {
            "id": 4,
            "song": "Giật mình trong đêm",
            "singer": "Tuấn hưng",
            "songCode": "124667",
            "thumbnail": "https://c-sf.smule.com/rs-s78/arr/fa/6b/3a2241ec-2b2f-41ab-9442-e02c80a935e4.jpg"
          },
          {
            "id": 5,
            "song": "Giật mình trong đêm",
            "singer": "Tuấn hưng",
            "songCode": "124667",
            "thumbnail": "https://c-sf.smule.com/rs-s78/arr/fa/6b/3a2241ec-2b2f-41ab-9442-e02c80a935e4.jpg"
          }
        ]
      }
    }
  }
</script>

<style scoped>
  .content{
    margin-top: 10px !important;
    text-align: left;
  }
  .thumbnail{
    float: left;
    margin-right: 5px;
    width: 60px;
    height: 60px;
  }
  .item{
    position: relative;
  }
  .songcode{
    position: absolute;
    top: 0.5rem;
    right: 0;
    background-color: #ececec;
    padding: 0.2rem 0.5rem;
    border-radius: 30rem;
  }
  .song{
    width: 16rem;
  }
  .singer{
    padding-left: 4rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/songplay/wap/SameSinger.vue